<template>
  <div
    class="is-flex is-flex-direction-column is-justify-content-center is-align-items-center c-w-100"
  >
    <div class="unit-price-container">
      <div class="unit-price-content" v-if="initialData.length > 0">
        <!-- Header -->
        <div class="unit-price-header">
          <div class="row-content-header">
            <div class="row-content-header-left">
              <div
                class="item-column-header index-number-unit-price border-right"
              >
                <p class="averta-bold color-white">No</p>
              </div>
              <div
                class="item-column-header index-id-item-unit-price border-right"
              >
                <p class="averta-bold color-white">ID</p>
              </div>
              <div
                class="item-column-header index-name-item-worker-unit-price border-right"
              >
                <p class="averta-bold color-white">NAMA ITEM PEKERJAAN</p>
              </div>
              <div
                class="item-column-header index-unit-price-unit border-right"
              >
                <p class="averta-bold color-white">SATUAN</p>
              </div>
            </div>

            <div
              class="row-content-header-right scroll-hidden"
              ref="leftTableSection"
              @scroll="onScroll('leftComponents')"
            >
              <div
                class="item-column-header index-unit-price-material border-right"
              >
                <p class="averta-bold color-white">HARGA MATERIAL</p>
                <div
                  @click="handleSort('material_price')"
                  class="is-clickable ml-1"
                >
                  <img
                    :src="require('@/assets/icons/arrow-top-bottom-used.svg')"
                    alt=""
                  />
                </div>
              </div>

              <div
                class="item-column-header index-unit-price-service border-right"
              >
                <p class="averta-bold color-white">HARGA JASA</p>
                <div
                  @click="handleSort('service_price')"
                  class="is-clickable ml-1"
                >
                  <img
                    :src="require('@/assets/icons/arrow-top-bottom-used.svg')"
                    alt=""
                  />
                </div>
              </div>

              <div
                class="item-column-header index-unit-price-unit-price border-right"
              >
                <p class="averta-bold color-white">HARGA SATUAN</p>
                <div
                  @click="handleSort('unit_price')"
                  class="is-clickable ml-1"
                >
                  <img
                    :src="require('@/assets/icons/arrow-top-bottom-used.svg')"
                    alt=""
                  />
                </div>
              </div>

              <div
                class="item-column-header index-unit-price-last-update border-right"
              >
                <p class="averta-bold color-white">TGL TER UPDATE</p>
                <div
                  @click="handleSort('last_updated_at')"
                  class="is-clickable ml-1"
                >
                  <img
                    :src="require('@/assets/icons/arrow-top-bottom-used.svg')"
                    alt=""
                  />
                </div>
              </div>

              <div class="item-column-header index-unit-price-action">
                <p class="averta-bold color-white">...</p>
              </div>
            </div>
          </div>
        </div>
        <!-- Header -->

        <!-- Body -->
        <div
          v-if="dataTable.length > 0"
          class="unit-price-body scroll-hidden"
          ref="unitPriceBody"
          @scroll="handleScroll"
        >
          <div
            class="row-content-body"
            v-for="(item, index) in dataTable"
            :key="index"
            :ref="index === dataTable.length - 1 ? 'lastItemRef' : null"
          >
            <div class="row-content-body-left">
              <div
                class="item-column-body index-number-unit-price border-right"
              >
                <p class="averta-bold">
                  {{
                    (currentPageUnitPrice - 1) * currentLimit.label +
                      (index + 1)
                  }}
                </p>
              </div>
              <div
                class="item-column-body index-id-item-unit-price border-right"
              >
                <p class="averta-bold">{{ item.id }}</p>
              </div>
              <div
                class="item-column-body is-justify-content-space-between index-name-item-worker-unit-price border-right is-relative overflow-auto gap-2"
              >
                <p class="averta-bold c-w-90">{{ item.note }}</p>
                <code
                  v-if="item.survey_id || item.project_id"
                  @mouseenter="showTooltip = item.id"
                >
                  <p>!</p>
                </code>

                <div
                  :class="
                    index === dataTable.length - 1
                      ? 'wrapper-tooltip-last'
                      : 'wrapper-tooltip'
                  "
                  class="wrapper-tooltip-size"
                  v-show="showTooltip === item.id"
                  @mouseleave="showTooltip = null"
                >
                  <div
                    class="is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center c-w-100 px-3 py-3"
                  >
                    <div
                      class="is-flex is-flex-direction-row is-justify-content-flex-start is-align-items-center w-100 gap-4"
                    >
                      <div
                        class="is-flex is-flex-direction-column is-justify-content-center is-align-items-flex-start"
                      >
                        <p class="averta-bold">Survey ID</p>
                        <p class="averta-regular">
                          {{ item.survey_id ? item.survey_id : "-" }}
                        </p>
                      </div>
                    </div>

                    <div
                      class="button-tooltip"
                      @click="goToDetail(item.survey_id, item.project_id)"
                    >
                      <ArrowRightIconLong />
                    </div>
                  </div>
                </div>
              </div>
              <div class="item-column-body index-unit-price-unit border-right">
                <p class="averta-bold">{{ item.name }}</p>
              </div>
            </div>

            <div
              class="row-content-body-right scroll-hidden"
              ref="rightTableSection"
              @scroll="onScroll('middleComponents')"
            >
              <div
                class="item-column-body is-justify-content-space-between index-unit-price-material border-right"
              >
                <p class="averta-bold">Rp.</p>
                <p class="averta-bold">
                  {{
                    item.material_price
                      ? formatThousand(item.material_price)
                      : 0
                  }}
                </p>
              </div>
              <div
                class="item-column-body is-justify-content-space-between index-unit-price-material border-right"
              >
                <p class="averta-bold">Rp.</p>
                <p class="averta-bold">
                  {{
                    item.service_price ? formatThousand(item.service_price) : 0
                  }}
                </p>
              </div>
              <div
                class="item-column-body is-justify-content-space-between index-unit-price-material border-right"
              >
                <p class="averta-bold">Rp.</p>
                <p class="averta-bold">
                  {{ formatThousand(item.unit_price) }}
                </p>
              </div>
              <div
                class="item-column-body is-justify-content-center index-unit-price-material border-right"
              >
                <p class="averta-bold">
                  {{ formatDate(item.last_updated_at) }}
                </p>
              </div>
              <div class="item-column-body index-unit-price-action">
                <div
                  class="is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center gap-4"
                >
                  <div class="is-clickable" @click="() => handleEdit(item)">
                    <EditIcon color="black" size="15" />
                  </div>
                  <div class="is-clickable" @click="() => handleDelete(item)">
                    <TrashIcon width="18" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Body -->

        <div
          v-else
          class="is-flex is-justify-content-center is-align-items-center empty-data-state"
        >
          <p class="averta-bold color-gray-500">Tidak ada data</p>
        </div>
        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false">
          <SpinnerIcon />
        </b-loading>
      </div>
      <div v-else class="column c-w-100 has-text-centered">
        <ProyekEmptyIcon />
        <p class="averta-bold mt-2">Data Tidak Ditemukan</p>
      </div>
    </div>
    <div
      v-if="initialData.length > 0"
      style="background-color: #ffffff"
      class="is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center c-w-100 py-4 gap-3"
    >
      <div
        class="is-flex is-flex-direction-row is-justify-content-flex-start is-align-items-center"
      >
        <p style="font-size: 18px !important" class="averta-regular white-space-nowrap">
          {{ infoText }}
        </p>
      </div>

      <div
        class="is-flex is-flex-direction-row is-justify-content-flex-end is-align-items-center gap-4 c-w-100"
      >
        <div
          class="is-flex is-flex-direction-row is-justify-content-center c-w-auto"
        >
          <b-field>
            <div class="is-relative">
              <b-input
                type="search"
                v-model="inputCurrentPage"
                @input="handlePageInput"
                class="custome-input-number"
              >
              </b-input>
              <div
                class="is-absolute wrapper-wording-max-current-page"
              >
                <div class="wording-max-current-page">
                  <p
                    class="averta-regular color-gray"
                    style="font-size: 1rem !important"
                  >
                    / {{ totalPageUnitPrice }}
                  </p>
                </div>
              </div>
            </div>
            <p class="control">
              <b-button
                :type="disbledPageInput ? 'is-light' : ' is-primary'"
                label="Cari"
                @click="clickPageInput"
                :disabled="disbledPageInput"
              />
            </p>
          </b-field>
        </div>

        <b-pagination
          :total="totalDataUnitPrice"
          v-model="currentPage"
          :range-before="rangeBefore"
          :range-after="rangeAfter"
          :order="order"
          :size="size"
          :simple="isSimple"
          :rounded="isRounded"
          :per-page="currentLimit.label"
          :icon-prev="prevIcon"
          :icon-next="nextIcon"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
          :page-input="pageInput"
          :debounce-page-input="inputDebounce"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { formatCurrency, alertErrorMessage, toastMessage } from '@/helpers'
import {
  EditIcon,
  TrashIcon,
  ArrowRightIconLong,
  SpinnerIcon,
  ProyekEmptyIcon
} from '@/components/icons'
import discardImage from '@/assets/img/delete-area-component.png'

export default {
  name: 'TableUnitPrice',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    initialData: {
      type: Array,
      default: () => []
    },
    refreshData: {
      type: Function
    },
    totalDataUnitPrice: {
      type: Number,
      default: 0
    },
    totalPageUnitPrice: {
      type: Number,
      default: 0
    },
    currentPageUnitPrice: {
      type: Number,
      default: 0
    },
    currentLimit: {
      type: Object,
      default: () => {}
    },
    infoText: {
      type: String,
      default: ''
    }
  },
  components: {
    EditIcon,
    TrashIcon,
    ArrowRightIconLong,
    SpinnerIcon,
    ProyekEmptyIcon
  },
  data () {
    return {
      isLoading: false,
      sortBy: null,
      sortType: null,
      dataTable: [],
      isSyncingScroll: false,
      showTooltip: null,
      currentPerPage: 10,
      currentPage: 1,
      scrollPosition: 0,
      inputCurrentPage: 1,

      // Pagination
      rangeBefore: 1,
      rangeAfter: 1,
      order: '',
      size: '',
      isSimple: false,
      isRounded: false,
      pageInput: false,
      prevIcon: 'chevron-left',
      nextIcon: 'chevron-right',
      inputDebounce: '2000'
    }
  },
  computed: {
    ...mapGetters({
      url: 'setup/getUrl',
      user: 'auth/user',
      S: 'unitPrice/staticUnitPrice'
    }),
    isSM () {
      if (this.user.roles[0].name === 'Site Manager') {
        return true
      }
      return false
    },
    isBS () {
      if (
        this.user.roles[0].name === 'Account Manager' ||
        this.user.roles[0].name === 'Business Support'
      ) {
        return true
      }
      return false
    },
    isKonsultan () {
      if (this.roleName === 'Konsultan Survey') {
        return true
      }
      return false
    },
    isPurchasing () {
      if (this.roleName === 'Purchasing') {
        return true
      }
      return false
    },
    maxValueCurrentPage () {
      return Math.ceil(this.totalDataUnitPrice / this.currentPerPage)
    },
    disbledPageInput () {
      if (this.inputCurrentPage > this.maxValueCurrentPage) {
        return true
      }
      return false
    }
  },
  methods: {
    formatThousand (val) {
      return formatCurrency(val, true)
    },
    formatDate (val) {
      if (!val) return '-'
      return moment(val).format('DD MMM YYYY')
    },
    handleEdit (data) {
      this.$router.push({
        path: `/am/form-unit-price/${this.$route.params.vendorId}`,
        query: { noteId: data.id }
      })
    },
    handleDelete (data) {
      this.$swal({
        imageUrl: discardImage,
        imageAlt: 'cancel offering',
        width: '600px',
        padding: '10px 10px 30px 10px',
        title: '<p class="averta-bold label-22">Hapus Item Pekerjaan Ini?</p>',
        html:
          '<p class="averta-reguler">Seluruh informasi pada item pekerjaan ini akan terhapus.</p>',
        showCancelButton: true,
        confirmButtonText: 'Hapus',
        cancelButtonText: 'Batalkan',
        customClass: {
          confirmButton: 'btn-hapus-detail-component',
          cancelButton: 'btn-batal-detail-component'
        }
      }).then(result => {
        if (result.isConfirmed) {
          this.isLoading = true
          const payload = {
            url: this.url,
            id: data.id
          }
          this.$store
            .dispatch('unitPrice/deleteItemWorkingUnitPrice', payload)
            .then(() => {
              toastMessage('Data Berhasil Dihapus', 'is-dark')
              this.refreshData({ refresh: true })
              this.isLoading = false
            })
            .catch(err => {
              this.isLoading = false
              alertErrorMessage(err)
            })
        }
      })
    },
    handleSort (type) {
      if (type !== this.sortBy || !this.sortBy) {
        this.sortBy = type
        this.sortType = 'desc'
      } else {
        if (this.sortType === 'desc') {
          this.sortType = 'asc'
        } else if (this.sortType === 'asc') {
          this.sortBy = null
          this.sortType = null
        }
      }

      this.refreshData({
        refresh: true,
        sortBy: this.sortBy,
        sortType: this.sortType,
        hideLoading: true
      })
    },
    onScroll (source) {
      if (this.isSyncingScroll) return
      this.isSyncingScroll = true

      const left = this.$refs.leftTableSection
      const rights = this.$refs.rightTableSection

      if (source === 'leftComponents') {
        rights.forEach(r => {
          r.scrollLeft = left.scrollLeft
        })
      } else {
        const active = event.target
        left.scrollLeft = active.scrollLeft

        rights.forEach(r => {
          if (r !== active) {
            r.scrollLeft = active.scrollLeft
          }
        })
      }

      requestAnimationFrame(() => {
        this.isSyncingScroll = false
      })
    },
    goToDetail (surveyId, projectId) {
      let rolePath = ''

      if (this.isBS) {
        rolePath = 'am'
      } else if (this.isSM) {
        rolePath = 'sm'
      } else if (this.isKonsultan) {
        rolePath = 'konsultan'
      } else if (this.isPurchasing) {
        rolePath = 'purchasing'
      }

      if (!rolePath) return

      if (!projectId) {
        this.$router.push({
          path: `/${rolePath}/project/survey/${surveyId}/detail`
        })
      } else {
        this.$router.push({
          path: `/${rolePath}/project/${projectId}/detail`
        })
      }
    },
    observeLastItem () {
      const lastItem = this.$refs.lastItemRef?.[0]
      if (!lastItem) return

      const observer = new IntersectionObserver(
        entries => {
          if (entries[0].isIntersecting && !this.isLoading) {
            this.$emit('loadMore')
          }
        },
        {
          root: this.$el.querySelector('.unit-price-body'),
          threshold: 1.0
        }
      )

      observer.observe(lastItem)
    },
    handlePageInput (val) {
      this.inputCurrentPage = Number(val)
    },
    clickPageInput () {
      this.refreshData({
        refresh: true,
        sortBy: this.sortBy,
        sortType: this.sortType,
        hideLoading: true,
        page: this.inputCurrentPage
      })
    },
    handleScroll () {
      if (this.$refs.unitPriceBody) {
        this.scrollPosition = this.$refs.unitPriceBody.scrollTop
      }
    },
    resetScroll () {
      if (this.$refs.unitPriceBody) {
        this.$refs.unitPriceBody.scrollTop = 0
      }
    }
  },
  created () {
    this.dataTable = this.initialData
  },
  mounted () {
    this.observeLastItem()
  },
  watch: {
    initialData: {
      handler (val) {
        this.dataTable = val
      },
      deep: true
    },
    dataTable () {
      this.$nextTick(() => {
        this.observeLastItem()
      })
    },
    currentPageUnitPrice (newVal) {
      this.currentPage = newVal
      this.inputCurrentPage = newVal
    },
    currentPage: {
      handler (newVal) {
        this.refreshData({
          refresh: true,
          sortBy: this.sortBy,
          sortType: this.sortType,
          hideLoading: true,
          page: newVal
        })
        if (newVal) {
          this.resetScroll()
        }
      }
    },
    currentLimit: {
      handler (newVal) {
        if (newVal) {
          this.resetScroll()
        }
      }
    }
  }
}
</script>

<style scoped>
p {
  font-size: 12px !important;
}

.unit-price-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  height: max-content;
  min-height: max-content;
  max-height: max-content;
  overflow: hidden;
  border-radius: 10px;
  background-color: transparent;
  border: 1px solid #e0e0e0;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1),
    0 8px 10px -6px rgb(0 0 0 / 0.1);
}

.unit-price-header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-width: 100%;
  max-width: 100% !important;
  height: 55px;
  min-height: 55px;
  max-height: 55px !important;
  overflow: hidden;
  background-color: #636363;
  box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1),
    0 8px 10px -6px rgb(0 0 0 / 0.1);
}

.unit-price-body {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 100%;
  max-width: 100% !important;
  height: auto !important;
  min-height: none !important;
  max-height: 400px !important;
  overflow-y: auto;
}

.unit-price-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 100%;
  max-width: 100% !important;
  height: 100%;
  min-height: 100%;
  max-height: 100%;
  overflow: auto;
  box-sizing: border-box;
}

.row-content-header {
  height: 100% !important;
  min-height: 100% !important;
  max-height: 100% !important;
  border-bottom: 3px solid #e0e0e0;
}

.row-content-body {
  height: 80px !important;
  min-height: 80px !important;
  max-height: 80px !important;
}

.row-content-header,
.row-content-body {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-width: none;
  max-width: 100%;
  background: transparent;
}

.row-content-body:hover {
  cursor: pointer;
}

.row-content-body {
  border-bottom: 1px solid #e0e0e0;
}

.row-content-body:nth-child(odd) {
  background-color: #ffffff;
}

.row-content-body:nth-child(even) {
  background-color: #f2f2f2;
}

.row-content-body:last-child {
  border-bottom: none;
}

.row-content-header-left,
.row-content-body-left {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 40%;
  min-width: none;
  max-width: 40%;
  height: 100%;
  background-color: transparent;
  border-right: 3px solid #e0e0e0;
}

.row-content-header-right,
.row-content-body-right {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 60%;
  min-width: none;
  max-width: 60%;
  height: 100%;
  background-color: transparent;
  overflow-y: auto;
}

.row-content-body-right {
  background-color: transparent;
}

.scroll-hidden::-webkit-scrollbar {
  display: none;
}

.scroll-hidden {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.row-content-header-left,
.row-content-header-right {
  border-bottom: 1px solid #e0e0e0;
}

.item-column-header,
.item-column-body {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: max-content;
  height: 100%;
  min-height: 100%;
  max-height: 100% !important;
  padding: 10px;
}

.border-right {
  border-right: 1px solid #e0e0e0;
}

.index-number-unit-price {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
}

.index-id-item-unit-price {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
}

.index-name-item-worker-unit-price {
  width: 100%;
  min-width: none;
  max-width: 100%;
}

.index-unit-price-unit {
  width: 65px;
  min-width: 65px;
  max-width: 65px;
}

.index-unit-price-material,
.index-unit-price-service,
.index-unit-price-unit-price,
.index-unit-price-last-update {
  width: 22.5% !important;
  max-width: 22.5% !important;
  min-width: 22.5% !important;
}

.index-unit-price-action {
  width: 10% !important;
  max-width: 10% !important;
  min-width: 10% !important;
}

.empty-data-state {
  width: 100%;
  height: 100%;
  min-height: 50px;
  max-height: 100% !important;
  background-color: transparent;
}

code {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
  flex-shrink: 0;
  background: #f2f2f2;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

.wrapper-tooltip-size {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: max-content;
  background-color: #ffffff;
  z-index: 99999 !important;
  border-radius: 10px;
  box-shadow: 1px 1px 34px 7px rgba(105, 105, 105, 0.15);
  -webkit-box-shadow: 1px 1px 34px 7px rgba(105, 105, 105, 0.15);
  -moz-box-shadow: 1px 1px 34px 7px rgba(105, 105, 105, 0.15);
}

.wrapper-tooltip {
  position: absolute;
  top: 10px;
  right: 10px;
}

.wrapper-tooltip-last {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.button-tooltip {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  flex-shrink: 0;
  cursor: pointer;
  background: #d5262e;
  border-radius: 50%;
}

.wrapper-wording-max-current-page {
  top: 0;
  right: 30px;
  width: 65px;
  height: 100%;
  z-index: 999;
}

.wording-max-current-page {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translate(50%, -50%);
}
</style>

<style>
.custome-input-number .input {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
}

.pagination-link.is-current {
  background: #3298dc !important;
  border-color: #3298dc !important;
}
</style>
